import {ShieldCheckIcon, ShieldIcon, ShieldSlashIcon} from '@primer/octicons-react'

export type SecurityAlertIconProps = {
  status: string
}

export function SecurityAlertIcon({status}: SecurityAlertIconProps) {
  switch (status) {
    case 'FIXED':
      return <ShieldCheckIcon className="fgColor-done" />
    case 'OPEN':
      return <ShieldIcon className="fgColor-open" />
    case 'DISMISSED':
      return <ShieldSlashIcon className="fgColor-closed" />
    default:
      return <ShieldIcon className="fgColor-open" />
  }
}
